document.addEventListener('DOMContentLoaded', function () {
  const blocks = document.querySelectorAll('[data-read-more]');

  blocks.forEach(function (block) {
    const inner = block.querySelector('[data-read-more-inner]');
    const content = block.querySelector('[data-read-more-content]');
    const toggle = block.querySelector('[data-read-more-toggle]');
    const toggleText = toggle ? toggle.querySelector('.product-description-read-more__text') : null;

    if (!inner || !content || !toggle || !toggleText) return;

    const styles = window.getComputedStyle(content);
    let lineHeight = parseFloat(styles.lineHeight);

    if (isNaN(lineHeight)) {
      const fontSize = parseFloat(styles.fontSize);
      lineHeight = fontSize * 1.2;
    }

    const collapsedHeight = lineHeight * 5.5;
    const fullHeight = content.scrollHeight;

    if (fullHeight <= collapsedHeight + 2) {
      toggle.style.display = 'none';
      inner.style.maxHeight = 'none';
      block.classList.remove('needs-read-more');
      return;
    }

    block.classList.add('needs-read-more');
    inner.style.maxHeight = collapsedHeight + 'px';

    toggle.addEventListener('click', function () {
      const isExpanded = block.classList.contains('expanded');

      if (isExpanded) {
        inner.style.maxHeight = collapsedHeight + 'px';
        block.classList.remove('expanded');
        toggleText.textContent = 'Read more';
      } else {
        inner.style.maxHeight = content.scrollHeight + 'px';
        block.classList.add('expanded');
        toggleText.textContent = 'Read less';
      }
    });

    window.addEventListener('resize', function () {
      const updatedFullHeight = content.scrollHeight;

      if (updatedFullHeight <= collapsedHeight + 2) {
        toggle.style.display = 'none';
        inner.style.maxHeight = 'none';
        block.classList.remove('needs-read-more', 'expanded');
        return;
      }

      toggle.style.display = '';
      block.classList.add('needs-read-more');

      if (block.classList.contains('expanded')) {
        inner.style.maxHeight = updatedFullHeight + 'px';
      } else {
        inner.style.maxHeight = collapsedHeight + 'px';
      }
    });
  });

  const popup = document.getElementById('enquiry-popup');
  const openBtn = document.getElementById('open-enquiry-popup');
  const closeBtn = document.getElementById('close-enquiry-popup');
  const closeOverlay = document.getElementById('close-enquiry-popup-overlay');
  const enquiryForm = document.getElementById('product_enquiry_form');

  if (openBtn && popup) {
    openBtn.addEventListener('click', function () {
      popup.hidden = false;
      document.body.classList.add('enquiry-popup-open');
    });

    function closePopup() {
      popup.hidden = true;
      document.body.classList.remove('enquiry-popup-open');
    }

    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (closeOverlay) closeOverlay.addEventListener('click', closePopup);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !popup.hidden) {
        closePopup();
      }
    });
  }

  if (enquiryForm) {
    enquiryForm.addEventListener('submit', function (event) {
      if (!enquiryForm.checkValidity()) {
        event.preventDefault();
        enquiryForm.reportValidity();
      }
    });
  }

  if (popup) {
    const successMessage = popup.querySelector('.form-status, .form__message');
    const errorMessage = popup.querySelector('.errors, .default-errors, .form-errors');

    if (successMessage) {
      popup.hidden = false;
      document.body.classList.add('enquiry-popup-open');
    }

    if (errorMessage) {
      popup.hidden = false;
      document.body.classList.add('enquiry-popup-open');
    }
  }  
});